type MoleculeCardTitleProps = {
  title: string;
  description?: string;
};

export const MoleculeCardTitle = ({
  title,
  description,
}: MoleculeCardTitleProps) => {
  return (
    <div className="flex flex-col">
      <h3 className="txt-medium-bold text-text-primary">{title}</h3>
      {description && (
        <p className="txt-small-regular text-text-tertiary">{description}</p>
      )}
    </div>
  );
};
